import { EvaluationType } from '../api/enumerations';

export const factorTypes = [
  EvaluationType.AUTOFACTORS,
  EvaluationType.SIMPFACTORS,
  EvaluationType.COMPLETEFACTORS,
];

export const inferencesTypes = [
  EvaluationType.AUTOINFERENCES,
  EvaluationType.SIMPINFERENCES,
  EvaluationType.COMPLETEINFERENCES,
];
